import React from 'react';
import { Typography, Card, CardMedia, Grid, CardContent } from '@mui/material';

const ProjectCardDetail = (props) => {
    // console.log("props data is", props);
    let {url, image, title , viewCode} = props; 

    return (
        <>
            <Grid item className="CardCover" lg={3} md={3} sm={4} xs={11} style={{cursor:'pointer', marginBottom:'1rem'}} >
                <Card elevation={5} style={{ borderRadius: '1rem' }}>
                    <div style={{height:'200px', display:'flex', alignItems:'center', padding:'1rem'}}
                        onClick={()=> window.open(url, '_blank')}>
                    <CardMedia
                        component={'img'}
                        image= {image}
                        style={{objectFit:'cover', width:'100%'}}
                    ></CardMedia>
                    </div>
                    <CardContent style={{textAlign:'center', fontWeight:'bold'}}>
                        <Typography variant="h5" style={{ fontFamily: 'Patua One'}}> {title}</Typography>
                        <Typography variant="subtitle1" style={{fontFamily: 'Patua One', color:'rgb(67, 14, 121)'}}
                         onClick={()=> window.open(viewCode, '_blank')}> ViewCode </Typography>
                    </CardContent>
                    
                </Card>
            </Grid>
        </>
    );
}
export default ProjectCardDetail;